import { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { startCheckout } from "@/lib/api";

export const CheckoutButton = ({ id = "pricing", className = "" }) => {
  const [loading, setLoading] = useState(false);

  const go = async () => {
    setLoading(true);
    try {
      const { checkout_url } = await startCheckout();
      window.location.href = checkout_url;
    } catch (err) {
      setLoading(false);
      toast.error("Couldn't open checkout. Please try again.");
    }
  };

  return (
    <button
      type="button"
      onClick={go}
      disabled={loading}
      data-testid={`${id}-subscribe-button`}
      className={`inline-flex h-12 items-center justify-center gap-2 rounded-full bg-pink px-6 font-semibold text-white transition-shadow duration-300 hover:shadow-[0_0_24px_hsl(var(--secondary)/0.6)] disabled:opacity-60 ${className}`}
    >
      {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />}
      Subscribe for €4.99/month
    </button>
  );
};
